export const defaultConfig = {
    //localhost
    // baseAPIUrl: "http://192.168.0.236/new-project/public/api/",
    // Userimage: "http://192.168.0.236/new-project/public/img/users/profile-photos/",

    //BT 
    baseAPIUrl: "https://laravel9.etrueconcept.com/swag_shack/api/",
    Userimage: "https://laravel9.etrueconcept.com/swag_shack/img/users/profile-photos/",
    
    //local
    // baseAPIUrl: "http://192.168.0.48/swagShack/api/",
    // Userimage: "http://192.168.0.48/swagShack/api/img/users/profile-photos/",
 
};